class HtmlHelper {
	static swapNodes(a, b) {
		const aparent = a.parentNode;
		const asibling = a.nextSibling === b ? a : a.nextSibling;
		b.parentNode.insertBefore(a, b);
		aparent.insertBefore(b, asibling);
	}
}

export default HtmlHelper;
